// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__2lgkF","text_shadow":"Button_text_shadow__1dcR_"};